import { SharedStyles } from '@opencare/shared-styles';
import React from 'react';
import styled, { css } from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { Modal as CrownModal } from 'opencare-crown';
import { BaseBodyText } from 'pages/checkout/components/common/typographic-styled-components';
import type { ModalProps } from 'types/opencare-crown';

const StyledModalContent = styled.div`
  position: relative;

  z-index: 1001;

  padding: 52px 24px 28px 24px;
  background-color: ${SharedStyles.COLOR.SURFACE.PAGE.DEFAULT};
  border-radius: 12px;
  overflow: clip;
  border: 1px solid ${SharedStyles.COLOR.BORDER.DEFAULT.DEFAULT};
`;

export const StyledModal = styled(CrownModal).attrs<ModalProps>(({
  maskClosable = true,
  keyboard = true,
  children,
}) => ({
  centered: true,
  destroyOnClose: true,
  footer: null,
  closable: false,
  maskClosable,
  keyboard,
  style: {
    paddingBottom: 0,
  },
  maskStyle: {
    backgroundColor: SharedStyles.COLOR.SURFACE.PAGE.OVERLAY,
  },
  modalRender: () => (
    <StyledModalContent>
      {children}
    </StyledModalContent>
  ),
}))`
  && {
    &.ant-modal {
      /* Override the default pointer-events: none */
      pointer-events: initial;
      width: 520px;
      max-width: calc(100vw - 32px);
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  row-gap: 12px;
`;

export const ModalTitle = styled.h1`
  margin: 0;
  max-width: 420px;

  ${TYPOGRAPHY.CIRCULAR.black}
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  color: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};

  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE, SCREEN_SIZES.TABLET], css`
    font-size: 32px;
    line-height: 40px;
  `)}
`;

export const ModalSubtitle = styled(BaseBodyText)`
  max-width: 400px;
  text-align: center;
`;
